import { render, staticRenderFns } from "./donate.vue?vue&type=template&id=15fba53d&scoped=true"
import script from "./donate.vue?vue&type=script&setup=true&lang=js"
export * from "./donate.vue?vue&type=script&setup=true&lang=js"
import style0 from "./donate.vue?vue&type=style&index=0&id=15fba53d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fba53d",
  null
  
)

export default component.exports